export default __webpack_public_path__ + "static/media/logo.db0e8291.svg";